import { Component, OnInit } from '@angular/core';
import { Observable, of } from 'rxjs';
import { IBlogPostModel } from '@models';
import { BlogService } from '@src/app/backend/blog.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-blog-page',
  templateUrl: './blog-page.component.html',
  styleUrls: ['./blog-page.component.scss']
})
export class BlogPageComponent implements OnInit {
  public selectedPost$: Observable<any>;
  public posts$: Observable<any>;
  public blogForm: FormGroup;
  private dummyPost: IBlogPostModel = {
    title: 'Testing the Waters',
    subtitle: 'An Angular 10 review',
    body: '<p>Another 6 months, another Angular update promising a multitude of updates. So... what did we get with the latest update?</p>'
  };

  constructor(
    private blogService: BlogService,
    private fb: FormBuilder
  ) { }

  ngOnInit(): void {
    this.blogForm = this.fb.group({
      title: ['', Validators.required],
      subtitle: ['', Validators.required],
      body: ['', Validators.required]
    })
    // TODO: Hookup to actual facade and store
    this.selectedPost$ = of(this.dummyPost);

    this.posts$ = this.blogService.getBlogPosts();
  }

  createBlogPost() {
    this.blogService.createBlogPost(this.blogForm.value);
  }

}
